import { getFileUploadSignedURLThunk as getAccessSignedURLThunk } from "@modules/stepper/redux/thunk/documentThunk";
import { getFileUploadSignedURLThunk as getROWSignedURLThunk } from "@modules/stepper-row/redux/thunk/documentThunk";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { uploadFileWithFormDataThunk } from "@modules/provisional-payment/redux/thunk/application-detailThunk";

const signedUrlThunkMap: Record<string, any> = {
  access: getAccessSignedURLThunk,
  row: getROWSignedURLThunk,
};

export const genericUploadThunk = createAsyncThunk(
  "file/genericUpload",
  async (
    {
      file,
      moduleType,
      isEsign,
    }: { file: File; moduleType: "row" | "access"; isEsign?: boolean },
    { dispatch, rejectWithValue },
  ) => {
    try {
      const env = process.env.REACT_APP_ENV;
      console.log("isEsign:", isEsign);
      if (env === "prod") {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("moduletype", moduleType);
        // if (isEsign) {
        //   formData.append("isEsign", String(isEsign || false));
        // }
        return await dispatch(
          uploadFileWithFormDataThunk({
            payload: formData,
            ...(isEsign && { isEsign }),
          }),
        ).unwrap();
      }

      const selectedThunk = signedUrlThunkMap[moduleType];

      if (!selectedThunk) {
        throw new Error("Invalid module type");
      }

      return await dispatch(
        selectedThunk({
          fileName: file.name,
          fileSize: file.size.toString(),
          contentType: file.type,
          isEsign: isEsign || false,
        }),
      ).unwrap();
    } catch (error: any) {
      return rejectWithValue(error.message || "Upload failed");
    }
  },
);
